import {
  CatInlineNotification,
  CatIconWarningTriangle
} from 'components/blocks-components';
import styles from './outage-messages.module.scss';

type OutageMessageType = {
  heading: string;
};

export const OutageMessageBanner = ({
  heading
}: Readonly<OutageMessageType>) => {
  return (
    <div className={styles['inline-notifications__banner']}>
      <CatInlineNotification
        heading={heading}
        variant={'warning'}
        dismissible={true}
      >
        <CatIconWarningTriangle slot="before" />
      </CatInlineNotification>
    </div>
  );
};
